export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  likes: number;
  comments: number;
  tags: string[];
  image: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '云南大理七日深度游：邂逅苍山洱海的浪漫时光',
    excerpt: '大理，一个让人来了就不想走的地方。从古城到喜洲，从双廊到沙溪，七天带你领略最真实的大理风土人情。',
    content: `<p>大理，这座千年古城，承载着太多关于诗与远方的想象。苍山如屏，洱海如镜，白族村寨散落其间，构成了一幅天然的山水画卷。</p>
<p>第一天抵达大理古城，踩着青石板路，穿梭在古色古香的街巷中。人民路上，手工艺人的小摊摆满了扎染布艺、银器首饰，每一件都透着手工的温度。</p>
<p>第二天前往喜洲古镇，这里保留着最完整的白族民居建筑群。转角楼、赵府、严家大院，一砖一瓦都诉说着茶马古道上"文献名邦"的辉煌过往。</p>
<p>第三天来到双廊，找一家临海的民宿住下。清晨推开窗，洱海的波光粼粼就在眼前。租一辆电动车，沿着环海东路骑行，风在耳边呼啸，自由得像只飞鸟。</p>
<p>第四天探访沙溪古镇，这个被时间遗忘的角落，还保留着茶马古道上最后的集市——寺登街。古戏台、兴教寺、玉津桥，仿佛穿越回了百年前。</p>
<p>第五天爬上苍山，乘坐索道到达中和寺，再徒步至洗马潭。站在海拔近4000米的高处，俯瞰整个洱海，那种壮阔让人心生敬畏。</p>
<p>第六天回到古城，找一家安静的咖啡馆，读一本书，写几张明信片，把大理的慢时光寄给远方的朋友。</p>
<p>第七天离开时，回头再看一眼苍山和洱海，心里默默说：大理，我一定会再来的。</p>`,
    categoryId: 'travel',
    categoryName: '旅行探险',
    author: '行走的蘑菇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-1&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: '8分钟',
    likes: 2347,
    comments: 186,
    tags: ['大理', '云南旅游', '深度游', '苍山洱海'],
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Yunnan%20landscape%20with%20Cangshan%20mountain%20and%20Erhai%20lake%2C%20traditional%20Bai%20architecture%2C%20warm%20golden%20hour%20light%2C%20serene%20travel%20atmosphere%2C%20earthy%20warm%20tones%2C%20artistic%20landscape%20photography%2C%20clean%20composition&width=720&height=420&seq=article-1&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-2',
    title: '手把手教你做正宗四川火锅：从锅底到蘸料的终极指南',
    excerpt: '冬天最幸福的事莫过于围炉吃火锅。今天分享我研究三年的秘制牛油锅底配方，在家也能做出火锅店的味道。',
    content: `<p>说起火锅，很多人首先想到的就是四川。那种麻辣鲜香的口感，总是让人欲罢不能。但你知道吗？在家也能做出不输火锅店的正宗川味火锅。</p>
<p>首先是锅底。我用了三年的业余时间反复调试，终于找到了这个堪称完美的牛油锅底配方。核心秘诀在于香料的比例和炒制火候。</p>
<p>牛油500克、菜籽油200克先下锅，小火熬化后加入姜片、大葱段、洋葱块，慢炸至金黄捞出。这一步是提香的关键。</p>
<p>然后加入郫县豆瓣酱150克，小火慢炒出红油。这个过程需要耐心，至少炒15分钟，直到油色红亮，香气四溢。中途加入剁碎的干辣椒和花椒。</p>
<p>加入八角、桂皮、香叶、草果、丁香、小茴香等香料，继续小火翻炒。当厨房里弥漫着让人流口水的香气时，加入高汤烧开。</p>
<p>蘸料方面，我推荐经典的香油蒜泥碟：蒜泥、香油、蚝油、醋、香菜、葱花，按个人口味调配。还有一种干碟也很赞：辣椒面、花椒面、花生碎、芝麻，蘸毛肚简直绝配。</p>
<p>涮品推荐：鲜毛肚、鸭肠、黄喉是火锅三宝；嫩牛肉要选牛里脊，逆纹切薄片；还有手工虾滑、鹌鹑蛋、藕片、土豆片，每一样都让人停不下来。</p>`,
    categoryId: 'food',
    categoryName: '美食烹饪',
    author: '吃货蘑菇君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20food%20lover%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-2&orientation=squarish',
    publishDate: '2026-08-03',
    readTime: '10分钟',
    likes: 3891,
    comments: 342,
    tags: ['火锅', '四川美食', '家常菜', '烹饪教程'],
    image: 'https://readdy.ai/api/search-image?query=Delicious%20Sichuan%20hotpot%20with%20rich%20red%20broth%20and%20fresh%20ingredients%20on%20wooden%20table%2C%20steaming%20warm%20atmosphere%2C%20earthy%20warm%20tones%2C%20appetizing%20food%20photography%2C%20clean%20composition%2C%20rustic%20dining%20scene&width=720&height=420&seq=article-2&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-3',
    title: '2026年最佳真无线耳机横评：十款热门型号全方位对比',
    excerpt: '花了两个月时间深度体验了市售十款主流真无线耳机，从音质、降噪、续航到佩戴舒适度，给你最真实的购买建议。',
    content: `<p>真无线耳机市场经过几年的高速发展，2026年的产品已经相当成熟。但面对琳琅满目的选择，消费者反而更难做决定。我们耗时两个月，深度评测了十款热门型号。</p>
<p>评测维度包括：音质表现（频响、解析力、声场）、主动降噪能力、通话质量、佩戴舒适度、续航表现、连接稳定性六个方面。</p>
<p>音质方面，索尼WF-1000XM6凭借全新的驱动单元和LDAC高清传输，在解析力和声场方面遥遥领先。但森海塞尔MOMENTUM True Wireless 4的人声表现更温暖自然，适合听人声为主的音乐。</p>
<p>降噪能力上，Bose QuietComfort Earbuds Ultra依然是最强王者，在地铁和飞机上几乎能隔绝所有噪音。但苹果AirPods Pro 3的自适应降噪在日常生活场景中更智能好用。</p>
<p>佩戴舒适度方面，三星Galaxy Buds3 Pro凭借小巧的腔体设计获得最高分。而续航表现则是JBL Tour Pro 3一枝独秀，配合充电盒可达40小时。</p>
<p>总结推荐：追求极致音质选索尼，看重降噪选Bose，苹果生态用户无脑AirPods Pro 3，预算有限的话，Nothing Ear (3)是性价比之王，不到千元的价格却有着越级的音质表现。</p>`,
    categoryId: 'tech',
    categoryName: '数码科技',
    author: '数码蘑菇侠',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20tech%20enthusiast%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-3&orientation=squarish',
    publishDate: '2026-08-01',
    readTime: '12分钟',
    likes: 5102,
    comments: 467,
    tags: ['真无线耳机', '数码评测', '横评对比', '2026推荐'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20wireless%20earbuds%20product%20photography%20on%20warm%20wooden%20surface%2C%20minimal%20tech%20aesthetic%2C%20soft%20natural%20lighting%2C%20earthy%20warm%20tones%2C%20clean%20composition%2C%20professional%20product%20shot%2C%20simple%20neutral%20background&width=720&height=420&seq=article-3&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-4',
    title: '《百年孤独》重读笔记：那些年少时看不懂的孤独，如今都懂了',
    excerpt: '十年后再读《百年孤独》，那些曾经觉得荒诞的情节，如今看来却是最深刻的人性寓言。',
    content: `<p>第一次读《百年孤独》是在大学，那时候觉得这本书真难读：人名重复、情节荒诞、时间线混乱。硬着头皮读完，只记住了"冰块"和"猪尾巴"。</p>
<p>十年后再翻开这本书，才发现自己当年错过了多少。马尔克斯不是在写奇幻故事，他是在用魔幻的笔触描绘最真实的人性。</p>
<p>布恩迪亚家族的每个人都在以不同的方式对抗孤独：何塞沉迷于炼金术，奥雷里亚诺上校躲在小作坊里做小金鱼，阿玛兰妲把自己裹在寿衣里，费尔南达固守着她那套贵族的繁文缛节……</p>
<p>每个人都活在自己的世界里，每个人都渴望被理解，却又不愿意走出自己的城堡。这不就是我们每个人的写照吗？</p>
<p>最让我触动的是乌尔苏拉。她活了100多岁，见证了家族的兴衰。她失明后，靠着记忆中的气味、声音和触感来感知世界，才发现"当一个人不再被外表迷惑时，才能看清事物的本质"。</p>
<p>马尔克斯说："生命中真正重要的不是你遭遇了什么，而是你记住了哪些事，又是如何铭记的。"合上书，我陷入了长久的沉默。那些年少时看不懂的孤独，在经历了生活的起落之后，终于感同身受。</p>`,
    categoryId: 'reading',
    categoryName: '读书思考',
    author: '书虫蘑菇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20book%20lover%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-4&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: '7分钟',
    likes: 1856,
    comments: 203,
    tags: ['百年孤独', '马尔克斯', '读书笔记', '文学经典'],
    image: 'https://readdy.ai/api/search-image?query=Vintage%20book%20with%20warm%20reading%20lamp%20on%20wooden%20desk%2C%20cozy%20library%20atmosphere%2C%20soft%20golden%20light%2C%20earthy%20warm%20tones%2C%20nostalgic%20literary%20photography%2C%20clean%20composition%2C%20simple%20background&width=720&height=420&seq=article-4&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-5',
    title: '从零开始的居家健身计划：每天20分钟，三个月蜕变',
    excerpt: '不用去健身房，不需要器械，只要每天20分钟，坚持三个月，你也能拥有理想身材。',
    content: `<p>很多人觉得健身一定要去健身房，一定要买很多器械。其实不然。只要你有一块瑜伽垫大小的空间和一颗坚持的心，在家也能完成高效的训练。</p>
<p>这套计划是我为自己设计的，严格执行了三个月，体重下降了8公斤，体脂率从25%降到18%。分享给所有想开始健身却不知道怎么做的朋友。</p>
<p>第一个月是适应期。每天的训练内容包括：热身5分钟（开合跳、高抬腿）、核心训练10分钟（平板支撑、卷腹、俄罗斯转体）、拉伸5分钟。重点是建立运动习惯，不追求强度。</p>
<p>第二个月进入强化期。引入HIIT训练：20秒全力运动+10秒休息，循环8组，总共只需4分钟。别小看这4分钟，它比慢跑40分钟消耗的热量还多。搭配深蹲、俯卧撑、波比跳等自重训练。</p>
<p>第三个月是塑形期。增加训练的多样性和强度：周一练上肢（俯卧撑变式、钻石俯卧撑）、周三练下肢（深蹲跳、弓步蹲）、周五练核心（登山者、V字卷腹）。</p>
<p>饮食方面，不需要节食，但要学会"吃对"：早餐多吃蛋白质，午餐正常吃，晚餐减半。戒掉含糖饮料，每天喝够2升水。你会发现，皮肤也会变好。</p>`,
    categoryId: 'fitness',
    categoryName: '运动健身',
    author: '健身蘑菇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20fitness%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-5&orientation=squarish',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    likes: 4203,
    comments: 521,
    tags: ['居家健身', '减肥计划', 'HIIT', '无器械训练'],
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20home%20workout%20scene%20with%20yoga%20mat%20on%20wooden%20floor%2C%20morning%20sunlight%20through%20window%2C%20peaceful%20wellness%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20composition%2C%20simple%20neutral%20background&width=720&height=420&seq=article-5&orientation=landscape',
    featured: true,
  },
  {
    id: 'article-6',
    title: '水彩入门完全指南：从工具选择到第一幅完整作品',
    excerpt: '水彩的魅力在于它的不可控性。这篇指南写给所有想学水彩却不知从何开始的你。',
    content: `<p>水彩是我认为最有灵性的绘画媒介。水和颜料在纸面上交融，产生出无法预测的美丽效果，每一次落笔都充满惊喜。</p>
<p>工具选择是第一步。水彩颜料推荐从温莎牛顿或史明克的学院级开始，12色足够。画笔需要一支圆头笔（6号或8号）、一支平头笔和一支细节笔。水彩纸推荐获多福或阿诗的中粗纹理，300g以上。</p>
<p>基础技法方面，水彩有四大核心技法：平涂（均匀着色）、渐变（从浓到淡）、湿画法（在湿润的纸面上作画，产生柔和的晕染效果）和干画法（在干燥纸面上叠加颜色，边缘清晰）。</p>
<p>很多人刚开始画水彩时最怕的是"失控"。其实水彩的魅力恰恰在于这种"失控"——你永远无法完全控制水和颜料的流动，但正是这种偶然性让每幅作品都独一无二。</p>
<p>我的建议是：不要追求画得"像"，而是享受过程。从简单的花卉开始练起，一朵花、一片叶子，慢慢找到属于自己的节奏和风格。</p>`,
    categoryId: 'art',
    categoryName: '艺术创作',
    author: '画笔蘑菇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20artist%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-6&orientation=squarish',
    publishDate: '2026-07-22',
    readTime: '9分钟',
    likes: 1678,
    comments: 145,
    tags: ['水彩画', '绘画教程', '艺术入门', '创作分享'],
    image: 'https://readdy.ai/api/search-image?query=Watercolor%20painting%20supplies%20on%20warm%20wooden%20desk%20with%20palette%20and%20brushes%2C%20soft%20natural%20light%2C%20artistic%20creative%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20composition%2C%20simple%20neutral%20background&width=720&height=420&seq=article-6&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-7',
    title: '日本京都赏枫秘境：避开人潮的五个绝美去处',
    excerpt: '秋天去京都看红叶，别再挤清水寺和岚山了。分享五个本地人才知道的赏枫秘境。',
    content: `<p>京都的秋天，是一年中最美的季节。漫山遍野的红叶，把千年古都染成了一幅浓墨重彩的画卷。但清水寺、岚山这些热门景点每到红叶季就人山人海，根本没法好好欣赏。</p>
<p>我整理了五个本地人才知道的赏枫秘境，分享给大家。</p>
<p>第一个是光明院。这座位于东福寺旁边的小寺院，游客极少，却有着京都最美的"波心庭"枯山水庭院。红叶季时，庭院两旁的枫树红得像火，倒映在白色的砂石上，美得让人窒息。</p>
<p>第二个是善峯寺。它藏在西山的半山腰上，需要坐巴士再步行30分钟才能到达。但当你站在寺门前，看到整面山坡都被红叶覆盖时，就会觉得一切辛苦都值得。</p>
<p>第三个是实相院。这里的"红叶地板"是一绝——漆黑的木质地板像镜子一样反射着窗外的红叶，形成一幅天然的画作。而且这里几乎没有外国游客，安静得能听见枫叶落地的声音。</p>`,
    categoryId: 'travel',
    categoryName: '旅行探险',
    author: '行走的蘑菇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-1&orientation=squarish',
    publishDate: '2026-07-20',
    readTime: '7分钟',
    likes: 1856,
    comments: 134,
    tags: ['京都', '赏枫', '日本旅行', '秘境推荐'],
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20autumn%20Kyoto%20Japanese%20temple%20garden%20with%20red%20maple%20leaves%2C%20serene%20zen%20atmosphere%2C%20warm%20golden%20light%2C%20earthy%20warm%20tones%2C%20artistic%20landscape%20photography%2C%20clean%20composition&width=720&height=420&seq=article-7&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-8',
    title: '深夜食堂同款：五道治愈系日式家常料理',
    excerpt: '从《深夜食堂》里走出来的美食，每一道都能温暖你的胃和心。',
    content: `<p>不知道有多少人和我一样，被《深夜食堂》里那些看似简单却充满温度的食物所打动。今天分享五道复刻成功的日式家常料理。</p>
<p>第一道是豚汁（猪肉味噌汤）。这是日本家庭的冬日标配：五花肉片、萝卜、胡萝卜、牛蒡、魔芋、豆腐，加入味噌调味，炖到萝卜透明、汤汁浓郁。配一碗白米饭，就是最温暖的晚餐。</p>
<p>第二道是猫饭。这道菜简单到不可思议——就是在热米饭上撒上木鱼花，淋一点酱油。但木鱼花在热气中微微舞动的样子，加上鲜美的味道，让人瞬间被治愈。</p>
<p>第三道是鸡蛋烧。关键在于火候和翻卷的手法。用专门的方形玉子烧锅，一层一层地把蛋液卷起来，每一层都要嫩而不焦。做好的鸡蛋烧切开来，层次分明，口感绵软。</p>`,
    categoryId: 'food',
    categoryName: '美食烹饪',
    author: '吃货蘑菇君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20food%20lover%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-2&orientation=squarish',
    publishDate: '2026-07-18',
    readTime: '8分钟',
    likes: 2678,
    comments: 198,
    tags: ['日式料理', '深夜食堂', '治愈美食', '家常菜'],
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20home%20cooking%20scene%20with%20miso%20soup%20and%20rice%20on%20wooden%20table%2C%20warm%20steaming%20atmosphere%2C%20earthy%20warm%20tones%2C%20appetizing%20food%20photography%2C%20clean%20composition%2C%20rustic%20dining&width=720&height=420&seq=article-8&orientation=landscape',
    featured: false,
  },
  {
    id: 'article-9',
    title: 'AI绘画工具实战对比：Midjourney vs Stable Diffusion 谁更强',
    excerpt: '实测五大AI绘画工具，从出图质量、操作难度到版权问题，帮你选出最适合的创作搭档。',
    content: `<p>AI绘画在2026年已经成为创作者不可或缺的工具。从最初的概念生成到现在的精细化创作，AI绘画工具的能力提升令人瞠目。本文实测五大主流AI绘画工具。</p>
<p>Midjourney依然在艺术性和美观度上领先。最新版本在光影处理、材质表现和构图美感上几乎可以媲美专业摄影师。但它的缺点也很明显：可控性差，很难精确还原脑海中的画面。</p>
<p>Stable Diffusion的优势在于开源和高度可控。搭配ControlNet插件，可以精确控制人物的姿态、构图和风格。对于需要商业化的设计工作来说，SD是更实用的选择。</p>
<p>DALL-E 3与ChatGPT的无缝集成是最大亮点。你不需要学习复杂的提示词技巧，用自然语言描述就能得到不错的结果。但它的风格自由度不如前两者。</p>
<p>Adobe Firefly的最大优势是无版权风险——它的训练数据全部来自Adobe Stock，生成的图片可以放心用于商业用途。对于设计师来说，这是一个重要的考量。</p>`,
    categoryId: 'tech',
    categoryName: '数码科技',
    author: '数码蘑菇侠',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20tech%20enthusiast%20avatar%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=avatar-3&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: '11分钟',
    likes: 3892,
    comments: 356,
    tags: ['AI绘画', 'Midjourney', 'Stable Diffusion', '工具评测'],
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20art%20creation%20concept%20with%20digital%20canvas%20on%20screen%2C%20warm%20ambient%20lighting%2C%20creative%20tech%20atmosphere%2C%20earthy%20warm%20tones%2C%20clean%20minimal%20composition%2C%20simple%20background&width=720&height=420&seq=article-9&orientation=landscape',
    featured: false,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(a => a.id === id);
};

export const getArticlesByCategory = (categoryId: string): Article[] => {
  return articles.filter(a => a.categoryId === categoryId);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter(a => a.featured);
};